import Axios from 'axios';
import moment from 'moment';
import QueryString from 'qs';

const axios = Axios.create();

function getSampleResponse(question) {
  switch (question.type) {
    case 'DROPDOWN':
    case 'CHECKBOX':
      return ['option A', 'option B'].toString();
    case 'DATE': {
      const dateArray = [];
      dateArray[0] = moment().format('DD-MM-YYYY');
      if (question.datePickerMode === 'datetime')
        dateArray.push(moment().format(question.use12Hours ? 'hh:mm a' : 'HH:mm'));
      return dateArray.toString();
    }
    default:
      return `${question.label || 'Untitled question'} - Response`;
  }
}

function getWebhookConfig(webhook, questions, whatsappNumber) {
  const questionsMap = {};
  questions.forEach((question) => {
    questionsMap[question.questionId] = question;
  });

  const webhookData = webhook;

  const { url, method, contentType } = webhookData;

  const headers = {};
  webhookData.headers.forEach((header) => {
    if (header.key && header.value) headers[header.key] = header.value;
  });

  let data = {};
  webhookData.keys.forEach((item) => {
    if (item.key) {
      const key = item.key;
      const question = questionsMap[item.questionId];
      const answer = getSampleResponse(question);
      data[key] = answer;
    }
  });

  webhookData.additionalFields.forEach((field) => {
    if (field.key && field.value) {
      data[field.key] = field.value;
    }
  });

  let axiosConfig;
  if (method === 'get') {
    axiosConfig = {
      method: 'get',
      params: data,
    };
  } else if (method === 'post' && contentType === 'application/json') {
    axiosConfig = {
      method: 'post',
      data,
    };
  } else if (method === 'post' && contentType === 'application/x-www-form-urlencoded') {
    axiosConfig = {
      method: 'post',
      data: QueryString.stringify(data),
    };
  }
  axiosConfig.url = url;
  axiosConfig.headers = headers;

  return axiosConfig;
}

export default getWebhookConfig;
